module.exports = __webpack_public_path__ + "img/offsetTradingIcon.95d95259.svg";